<template>
    <b-modal
            id="modalContactUs"
              size="lg"
             :hide-footer="true"
              title="Contact Us"
            @show="load">
      <b-container>
        <div v-show="!isShowSuccess">
        <b-row>
          <b-col class="colcenter">
            <h1><icon name="commenting-o" width="80px" height="80px"></icon></h1>
          </b-col>
        </b-row>
        <b-row>
        <b-col class="colcenter">
          <h3>Have any questions? Send us a message.</h3>
        </b-col>
      </b-row>
        <b-row>
        <b-col>
          <b-form-input placeholder="Name *" :state="this.infoValid.name.state" v-model="info.name"></b-form-input>
          <span v-if="infoValid.name.text" class="text-danger">{{infoValid.name.text}}</span>
        </b-col>
      </b-row>
        <b-row>
        <b-col>
          <b-form-input placeholder="Email address *" :state="this.infoValid.email.state" type="email" v-model="info.email"></b-form-input>
          <span v-if="infoValid.email.text" class="text-danger">{{infoValid.email.text}}</span>
        </b-col>
      </b-row>
        <b-row>
          <b-col>
            <b-form-textarea :rows="5"  :state="this.infoValid.message.state" placeholder="Message *" v-model="info.message"></b-form-textarea>
            <span v-if="infoValid.message.text" class="text-danger">{{infoValid.message.text}}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="colcenter">
            <b-btn :disabled="btnDisable" @click="submit">Send Message</b-btn>
          </b-col>
        </b-row>
      </div>
        <div v-show="isShowSuccess" class="colcenter">
          <b-row>
            <b-col>
              <h1><icon name="check" width="80px" height="80px"></icon></h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h1>Thanks for contacting us!</h1>
            </b-col>
          </b-row>
        <b-row>
          <b-col>
            <h3>We will get back to you very soon.</h3>
          </b-col>
          </b-row>
        </div>
      </b-container>
    </b-modal>
</template>

<script>
  import notification from '@/components/common/notification'

  export default {
    data () {
      return {
        info: {
          name: '',
          email: '',
          message: ''
        },
        btnDisable: false,
        infoValid: {
          name: {
            state: null,
            text: ''
          },
          email: {
            state: null,
            text: ''
          },
          message: {
            state: null,
            text: ''
          }
        },
        isShowSuccess: false
      }
    },
    methods: {
      submit () {
        this.clearValid(this.infoValid)
        let that = this
        if (this.validInfo()) {
          this.btnDisable = true
          this.$http.post(this.$store.getters['config/link']('sendMessage'), {
            Action: 'save-contact-info',
            FormData: JSON.stringify({
              FirstName: this.info.name,
              LastName: '',
              Company: '',
              Email: this.info.email,
              Phone: '',
              Comment: this.info.message,
              Page: 'SL360',
              PageInfo: 'SL360',
              FromSite: 'SL360',
              Source: '',
              fromsite: 'SL360'
            })
          }, {
            emulateJSON: true
          }).then(resp => {
            that.btnDisable = false
            if (resp.body.Status === 1) {
              that.isShowSuccess = true
            }
          }, resp => {
            notification.notice('error', 'Failed to sent contact information , please try again')
            this.btnDisable = false
          })
        }
      },
      validInfo () {
        let isValid = true
        if (!this.info.name) {
          this.infoValid.name.state = false
          this.infoValid.name.text = "It's required"
          isValid = false
        }
        if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
          this.infoValid.email.state = false
          this.infoValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.info.email) {
          this.infoValid.email.state = false
          this.infoValid.email.text = "It's required"
          isValid = false
        }
        if (!this.info.message) {
          this.infoValid.message.state = false
          this.infoValid.message.text = "It's required"
          isValid = false
        }
        return isValid
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      },
      load () {
        this.name = this.$store.getters['user/userInfo'].Name
        this.email = this.$store.getters['user/userInfo'].Email
        this.isShowSuccess = false
      }
    }
  }
</script>

<style scoped>
.colcenter{
  text-align: center;
}
  .row{
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MContactUs.vue